import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import {
    BaseFlex,
    FlexRow,
    RightFlexRow,
    CenteredFlexColumn,
    FlexColumn,
} from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled, { createGlobalStyle, css } from "styled-components";
import { TooltipWrapper } from "pro-features/components/BoxTitle/src/BoxTitle";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import {
    CircleSwitcherItem,
    LegendLabelText,
    LegendTextContainerRightSide,
    LegendWithOneLineFlexWrapper,
    SimpleDropdownItem,
} from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { LegendItemsContainer } from "app/components/React/legend/vertical-legends-with-search/styled";

export const BoxTitleContainer = styled(FlexRow)`
    ${setFontVariant("h5", colorsPalettes.carbon[500])}
    align-items: center;

    ${TooltipWrapper} {
        margin-top: -8px;
    }
`;

export const BoxSubtitleStyled = styled(BoxSubtitle)`
    ${setFontVariant("chip1", colorsPalettes.carbon[500])}
    ${BaseFlex} {
        align-items: center;
    }
`;

export const CircleSwitcherItemStyled = styled(CircleSwitcherItem)`
    /* override default sizes to match switcher */
    .SWReactIcons {
        ${({ isLocked }) =>
            !isLocked &&
            css`
                width: 20px;
                height: 20px;
            `}

        svg path {
            fill: ${({ isLocked, selected }) =>
                isLocked
                    ? colorsPalettes.indigo[300]
                    : selected
                      ? colorsPalettes.blue[400]
                      : colorsPalettes.carbon[200]};
        }
    }
`;

export const GraphHeaderActions = styled(RightFlexRow)`
    flex: 1;
`;

const ChartContainer = styled.div`
    margin-right: 24px;
    height: 100%;
    width: calc(100% - 248px);
`;

export const ChartContainerNoData = styled(CenteredFlexColumn)`
    width: 100%;
    height: 315px;
`;

export const Divider = styled.div`
    height: 1px;
    width: calc(100% + 48px);
    background: ${colorsPalettes.carbon[100]};
    margin: 18px -24px 0 -24px;

    @media (max-width: 1400px) {
        margin: 18px -24px 0 -24px;
    }
`;

export const TooltipStyles = createGlobalStyle`
.PlainTooltip-element.top {
    margin-top: -20px;
}
`;

export const LoaderContainer = styled(FlexColumn)`
    justify-content: center;
    width: 100%;
    height: 400px;
`;

export const ClicksOverTimeTitle = styled(I18n)`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])}
`;

export const ChartFilterBar = styled(FlexRow)`
    margin-top: 16px;
`;

export const SimpleDropdownItemStyled = styled(SimpleDropdownItem)`
    display: flex;
    flex-direction: row;

    .SWReactIcons {
        line-height: 50px;
        margin-right: 8px;
    }
`;

export const DropdownButtonIconWrapper = styled.div`
    line-height: 0;
    margin-right: 8px;
`;

export const LegendItemsContainerWrapper = styled(LegendItemsContainer)`
    height: 330px;
    ${LegendWithOneLineFlexWrapper} {
        ${LegendLabelText} {
            overflow: visible;
        }
    }
    ${LegendTextContainerRightSide} {
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        ${LegendLabelText} {
            overflow: hidden;
            max-width: none;
        }
    }
`;

export const LegendsContainer = styled.div`
    float: right;
    width: 248px;
    min-width: 248px;
    padding: 24px 16px 0px 18px;
    height: 100%;
    flex: 1 1 auto;
`;

export const TableHeaderText = styled.div`
    margin: 0;
    align-self: flex-end;
    padding-bottom: 4px;
    ${setFontVariant("captionTitle", colorsPalettes.carbon[400])}
`;

export const TableHeaderContainer = styled(FlexRow)`
    justify-content: space-between;
    margin-bottom: 6px;
    padding-right: 16px;
`;

export const TotalClicksLegendContainer = styled.div`
    padding-right: 16px;
    padding-left: 4px;
`;

export const Container = styled(FlexRow)`
    width: 100%;
`;
export const ChartContainerWrapper = styled(FlexColumn)`
    flex-grow: 1;
    height: 100%;
    gap: 30px;
    justify-content: space-between;
    padding: 16px 4px 16px 16px;
`;
